import { authorizedApi } from '../network/authorized-api';
import { Vendor } from '@/domains/vendor';

export const getVendors: () => Promise<Vendor[]> = () => authorizedApi.get(`/v1/vendors`);

export const createVendor: (name: string) => Promise<any> = (name) => authorizedApi.post(`/v1/vendors`, { name });

export const inviteVendorUser: (vendorId: number, email: string) => Promise<Vendor[]> = (vendorId, email) =>
  authorizedApi.post(`/v1/vendors/${vendorId}/users`, { email });
